import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'
import { booleantoString, removeExtraSlashes } from '../helper'
import { constants } from '../constants/constants'

class RenderAppliedFilter extends Component {
  constructor(props, context) {
    super(props, context)
  }

  renderAppliedFilter = () => {
    const { searchQuery } = this.props
    const searchQueryAfterRemovingQuickSearch = _.omit(
      searchQuery,
      'quickSearch',
    )
    return (
      Object.keys(searchQueryAfterRemovingQuickSearch).length > 0 && (
        <div className="view__applied-filter-container">
          <div>
            <Message id="filter.appliedFilter.label" />:
          </div>
          {this.renderAppliedFilterValues(searchQueryAfterRemovingQuickSearch)}
        </div>
      )
    )
  }

  renderValues = (searchQuery, key) => {
    if (key === 'isShared') {
      return booleantoString(searchQuery[key])
    } else if (key === 'size') {
      return `${searchQuery[key][0]} gb - ${searchQuery[key][1]} gb`
    } else if (key === 'path') {
      return removeExtraSlashes(searchQuery[key])
    }
    return searchQuery[key]
  }

  renderAppliedFilterValues = (searchQuery) => {
    const { user } = this.props
    return (
      <div className="view__applied-filter-content">
        {constants.AdvancedFilter.map((item) => {
          return (
            searchQuery[item.key] && (
              <div className="view__applied-filter-box" key={item.name}>
                <div className="view__applied-filter-key">
                  <Message id={`filter.${item.localizeId}`} />:
                </div>
                <div className="view__applied-filter-value">
                  {this.renderValues(searchQuery, item.key)}
                </div>
                <div className="view__applied-filter-close">
                  <span
                    className="ppvx_icon ppvx_icon--size_sm ppvx_icon-clear view__applied-filter-close-icon"
                    data-pa-pgrp={`dropzone:${user.accType}`}
                    data-pa-page={`dropzone:search:clear_filter:${user.accType}`}
                    data-pa-click="clear_filter"
                    onClick={() => this.props.clearAppliedFilter(item.key)}
                  />
                </div>
              </div>
            )
          )
        })}
      </div>
    )
  }

  render() {
    return <div>{this.renderAppliedFilter()}</div>
  }
}

export default RenderAppliedFilter
